webpackJsonp([52],{

/***/ "Mu6H":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/subscription-total-price_3a8a5f86b9e8c5d2d53f28be70045394.html";

/***/ }),

/***/ "ZKt+":
/***/ (function(module, exports, __webpack_require__) {

var SubscriptionTotalPrice = (function () {
    function SubscriptionTotalPrice() {
    }
    return SubscriptionTotalPrice;
}());
angular.module('animatronApp.SubscriptionTotalPrice', [])
    .component('subscriptionTotalPrice', {
    bindings: {
        totalPrice: '<',
        fullPrice: '<'
    },
    controller: SubscriptionTotalPrice,
    templateUrl: __webpack_require__("Mu6H")
});


/***/ })

});


// WEBPACK FOOTER //
// javascripts/52-bd880478516a225297ea.min.js